import React from 'react';
import { useTranslation } from 'react-i18next';
import { GenericTabs } from '@AMIEWEB/Common/Tabs/GenericTabs';
import { useParams } from 'react-router-dom';
import { CandidatePlacementPayPackagesWrapper } from './PlacementPayPackages/CandidatePlacementPayPackagesWrapper';
import { useInjectReducer, useInjectSaga } from 'redux-injectors';
import { orderDataReducer, orderDataSliceKey } from '@AMIEWEB/Order/Store/Order.redux';
import { orderDataSaga } from '@AMIEWEB/Order/Store/Order.saga';
import { DrawerFitted } from '@AMIEWEB/Common/Drawer/Drawer';
import { SearchDrawerContent } from '@AMIEWEB/GlobalSearch/SearchResultsPage';
import { useDispatch, useSelector } from 'react-redux';
import { selectSearchResults } from 'store/redux-store/global-search/selectors';
import { globalSearchActions } from 'store/redux-store/global-search/slice';
import { theme } from 'styles/global-styles';

export const PayPackagesTab = () => {
  const params = useParams<{ travelerId: string; brandId: string }>();
  const candidateId = Number(params?.travelerId);
  const { drawerData } = useSelector(selectSearchResults);
  const dispatch = useDispatch();

  // Candidate Profile needs OrderData saga to fetch Placement Pay Packages
  useInjectReducer({ key: orderDataSliceKey, reducer: orderDataReducer });
  useInjectSaga({ key: orderDataSliceKey, saga: orderDataSaga });

  return (
    <>
      <CandidatePlacementPayPackagesWrapper candidateId={candidateId} />
      <DrawerFitted
        onDrawerClose={() => {
          dispatch(globalSearchActions.setDrawerData({ open: false, data: undefined }));
        }}
        width={450}
        top={0}
        backgroundColor={theme.palette.framework.system.whisper}
        open={drawerData?.open ?? false}
        shadow={false}
      >
        {drawerData?.open && drawerData?.data ? (
          <SearchDrawerContent category="margin" data={drawerData?.data} />
        ) : null}
      </DrawerFitted>
    </>
  );
};
